import { createContext } from 'react';

export const IPContext = createContext({});